import React, { useEffect, useState, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const CarnivalSellerChallenge = () => {
  const [scenario, setScenario] = useState(null);
  const [userInput, setUserInput] = useState('');
  const [resultText, setResultText] = useState('');
  const [isLoss, setIsLoss] = useState(false);
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);
  const [correctAnswer, setCorrectAnswer] = useState(0);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(to top right, #fff0c1, #ffe6e6)',
      color: '#333',
      textAlign: 'center',
      margin: 0,
      padding: 0
    },
    header: {
      background: '#ff6b6b',
      padding: '25px',
      color: 'white',
      fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
      letterSpacing: '1px',
      boxShadow: '0 3px 10px rgba(0,0,0,0.2)'
    },
    container: {
      padding: '30px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    stall: {
      background: '#fff',
      borderRadius: '20px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      padding: '30px',
      margin: '20px auto',
      maxWidth: '700px',
      width: '100%'
    },
    input: {
      padding: '15px',
      fontSize: 'clamp(1rem, 4vw, 1.2rem)',
      borderRadius: '10px',
      border: '2px solid #ffd166',
      width: 'min(80%, 240px)',
      marginTop: '15px',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center'
    },
    button: {
      padding: '12px 24px',
      margin: '15px 10px',
      fontSize: 'clamp(1rem, 3vw, 1.2rem)',
      backgroundColor: '#06d6a0',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      cursor: 'pointer'
    },
    result: {
      fontSize: 'clamp(1rem, 3vw, 1.2rem)',
      fontWeight: 'bold',
      marginTop: '25px',
      minHeight: '30px'
    },
    background: {
      // background: 'url("https://i.imgur.com/IiUFTY3.png") no-repeat center',
      backgroundSize: 'contain',
      minHeight: '250px',
      marginTop: '25px',
      width: '100%'
    }
  };

  const generateScenario = () => {
    const scenarios = [
      { costTotal: 90, numToys: 3, sellingPrices: [30, 30, 30] },
      { costTotal: 90, numToys: 3, sellingPrices: [30, 30, 20] },
      { costTotal: 120, numToys: 4, sellingPrices: [40, 40, 40, 40] },
      { costTotal: 120, numToys: 4, sellingPrices: [40, 40, 40, 30] },
      { costTotal: 60, numToys: 3, sellingPrices: [10, 20, 25] },
      { costTotal: 100, numToys: 4, sellingPrices: [20, 25, 30, 25] }
    ];

    const s = scenarios[Math.floor(Math.random() * scenarios.length)];
    const costPerToy = s.costTotal / s.numToys;

    let total = 0;
    let loss = false;

    const list = s.sellingPrices.map((price, i) => {
      const diff = price - costPerToy;
      if (diff < 0) loss = true;
      total += diff;
      return `Toy ${i + 1} 🧸 sold for $${price}`;
    });

    setIsLoss(loss);
    setCorrectAnswer(parseFloat(total.toFixed(2)));
    setScenario({
      costTotal: s.costTotal,
      numToys: s.numToys,
      sales: list
    });
    setUserInput('');
    setResultText('');
  };

  const checkAnswer = () => {
    const input = parseFloat(userInput);
    if (isNaN(input)) {
      setResultText('❗ Please type a number!');
      return;
    }

    if (Math.abs(input - correctAnswer) < 0.01) {
      setResultText(`🎉✅ Correct! You made a ${isLoss ? 'loss' : 'profit'} of $${correctAnswer.toFixed(2)}!`);
      correctSoundRef.current.play();
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setResultText(`❌ Oops! The correct ${isLoss ? 'loss' : 'profit'} was $${correctAnswer.toFixed(2)}. Try again!`);
      wrongSoundRef.current.play();
    }
  };

  useEffect(() => {
    generateScenario();
  }, []);

  return (
    <div style={styles.body}>
      <header style={styles.header}>🎪 Carnival Seller Challenge</header>
      <div style={styles.container}>
        <div style={styles.stall}>
          <h2 style={{ fontSize: 'clamp(1.2rem, 4vw, 1.6rem)' }}>🧸 Can you run a profitable toy stall?</h2>
          {scenario && (
            <div style={{ margin: '20px 0', fontSize: 'clamp(1rem, 3vw, 1.1rem)', color: '#555' }}>
              🎯 You spent <strong>${scenario.costTotal}</strong> to buy <strong>{scenario.numToys} toys</strong>.
              <br /><br />
              Here’s what you sold them for:
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {scenario.sales.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          )}
          <div style={{ fontSize: 'clamp(1rem, 3vw, 1.2rem)', marginTop: '15px' }}>
            Enter your total <strong>{isLoss ? 'loss' : 'profit'}</strong> below:
          </div>
          <input
            type="number"
            value={userInput}
            placeholder="Type your answer here..."
            onChange={(e) => setUserInput(e.target.value)}
            style={styles.input}
          />
          <div>
            <button onClick={checkAnswer} style={styles.button}>✅ Check Answer</button>
            <button onClick={generateScenario} style={styles.button}>🎡 Next Challenge</button>
          </div>
          <div style={styles.result}>{resultText}</div>
        </div>

        <div style={styles.background}></div>

        <audio ref={correctSoundRef} src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_44b6f535f3.mp3?filename=success-kids-8082.mp3" />
        <audio ref={wrongSoundRef} src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_49d682b7f5.mp3?filename=wrong-3-199276.mp3" />
      </div>
    </div>
  );
};

export default CarnivalSellerChallenge;
